import React from 'react'
import EmbededEntityInput from '../input/embedded_entity'
import OptionsField from 'react-mobx-admin/components/common/field/opts'
import SelectInput from '../input/select'

const Testers = ({ store, label, disabledEntityFromBatch, ...rest }) => {
  const TestersEditForm = ({ store, state, record, updateFormField, errors }) => {

    return (
      <div className='row'>
        {state && !state.edited && <div className='col-sm-12 col-lg-6'>
          <SelectInput
            attr={'tester_group'}
            label={store.__('group')}
            labelattr='text'
            valueattr='value'
            onChange={updateFormField}
            optionsattr={'TestingGroups'}
            optionsrecord={store.options}
            record={record}
            errors={errors} />
        </div>}
        <div className='col-sm-12 col-lg-8'>
          <SelectInput
            attr={'id'}
            label={store.__('tester')}
            labelattr={val => val.tester_email + ' – ' + val.tester_id + ' – ' + val.platform_auth0}
            valueattr='id'
            onChange={updateFormField}
            optionsattr={'flyprivate_testing'}
            optionsrecord={store.options}
            record={record}
            errors={errors} />
        </div>
      </div>
    )
  }

  const attr = 'flyprivate_testing_testers'
  const toSave = (rec) => {
    if (rec.tester_group) {
      store.options.get('flyprivate_testing').map(i => {
        i.tester_group && i.tester_group === rec.tester_group
          && !store.cv.record.get(attr).find(j => j.id === i.id)
          && store.cv.record.get(attr).push(Object.assign({}, { id: i.id }))
      })
      delete rec.tester_group
    }
    if (rec.id && !store.cv.record.get(attr).find(j => j.id === rec.id)) {
      store.cv.record.get(attr).push(Object.assign({}, { id: rec.id }))
    }
    return rec
  }

  return (
    <EmbededEntityInput {...rest}
      attr={attr}
      store={store}
      disabled={!!disabledEntityFromBatch}
      items={store.cv.record.get(attr)}
      label={label || store.__('Testers')}
      add_title={store.__('Add item')}
      edit_title={store.__('Edit item')}
      errors={store.cv.errors}
      fields={[
        (attr, row) => (<OptionsField
          attr={attr}
          val={row[attr]}
          options={store.options.get('flyprivate_testing')}
          labelattr={val => val.tester_email + ' – ' + val.tester_id + ' – ' + val.platform_auth0}
          valueattr='id'
        />)
      ]}
      rowId={(row) => null}
      EditForm={TestersEditForm}
      onAddRow={(saved) => toSave(saved)}
    />
  )
}
export default Testers
